import { render, staticRenderFns } from "./ChainsList.vue?vue&type=template&id=26682978&scoped=true&"
import script from "./ChainsList.vue?vue&type=script&lang=js&"
export * from "./ChainsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26682978",
  null
  
)

export default component.exports